import styled from '@emotion/styled'
import React from 'react'
import { breakpoint, calcRem, colors, fonts } from '../../__styling'

export const StyledFootyLivesHerePromoStrapContainer = styled.a<{
    hideOnMobileAndApp: boolean
}>(({ hideOnMobileAndApp }) => ({
    display: hideOnMobileAndApp ? 'none' : 'flex',
    position: 'relative',
    paddingBottom: calcRem(16),
    textDecoration: 'none',

    [breakpoint('lg')]: {
        display: 'flex',
    },
}))

export const StyledBackgroundImage = styled('img')(() => ({
    width: '100%',
    height: calcRem(64),
    position: 'absolute',

    objectPosition: 'center top',

    objectFit: 'cover',
    overflow: 'hidden',

    [breakpoint('lg')]: {
        objectPosition: `center ${calcRem(-78)}`,
    },
}))

export const StyledInnerContainer = styled('div')({
    display: 'flex',
    width: '100%',
    height: calcRem(64),
    zIndex: 1,

    padding: calcRem(12, 16),
    gap: calcRem(12),
    textAlign: 'center',
    justifyContent: 'space-between',
    alignItems: 'center',
})

export const StyledInnerTextContainer = styled('div')({
    display: 'flex',

    textAlign: 'left',
    justifyContent: 'center',
    alignItems: 'center',

    [breakpoint('lg')]: {
        textAlign: 'center',
    },
})

export const StyledFootyLivesHereText = styled('p')({
    color: colors.white,
    fontFamily: fonts.thewest.sansSerif,
    fontSize: calcRem(16),
    fontWeight: 600,
    lineHeight: '120%',
    margin: 0,

    span: {
        color: '#FFC70A',
    },

    [breakpoint('lg')]: {
        fontSize: calcRem(22),
    },
})

export const MiniWaFootyLivesHereIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="104"
            height="40"
            viewBox="0 0 104 40"
            fill="none"
        >
            <path
                d="M51.4777 2.88945L51.8924 2.23394H50.7954L50.8356 0.575073L49.5245 1.55166V2.23394H48.9225L48.5078 2.88945H49.5245V6.91621L49.0028 7.41119L49.1232 7.5316L49.5245 7.07675L50.3807 7.93293L51.772 6.55501L51.6382 6.47474L51.1968 6.91621L50.7954 6.51487V2.88945H51.4777Z"
                fill="white"
            />
            <path
                d="M46.3153 2.0733C46.3153 2.0733 45.2584 3.04989 44.8972 3.04989V5.77899L45.8337 5.49805L44.041 8.02648C44.4959 7.37096 45.3788 7.21043 46.0343 7.66528C46.1949 7.78568 46.3153 7.90608 46.3955 8.06661L47.9875 6.84922V3.98635L46.8102 4.34755L48.4022 2.0733C47.6531 2.68869 46.6363 2.60842 46.3153 2.0733ZM46.7166 6.79571C45.9407 6.55491 45.0845 6.83584 44.643 7.49136L46.0611 5.45792L46.7166 5.25725V6.79571ZM46.5561 4.4412L46.1949 4.5616V3.26394C46.8102 3.42447 47.4524 3.18367 47.827 2.64855L46.5561 4.4412Z"
                fill="white"
            />
            <path
                d="M44.0002 6.14022L43.2242 6.91614L42.6891 6.34089V5.28403L44.4818 3.45126L43.1841 2.11346L41.4316 3.86597V6.67534L40.8965 7.21045L41.0169 7.33086L41.4717 6.88938L42.4885 7.90611L44.2008 6.23387L44.0002 6.14022ZM42.6891 3.50477L43.5052 4.32082L42.6891 5.13688V3.50477Z"
                fill="white"
            />
            <path
                d="M40.8704 6.43447L40.4155 6.87594L39.6797 6.14016V1.993L40.255 1.47126L40.1346 1.39099L39.6797 1.84584L38.5827 0.748852L37.3252 2.00638V0.775607C37.0844 1.01641 36.75 1.17695 36.3888 1.17695C35.8135 1.13681 35.2918 0.855875 34.6764 0.855875C33.9406 0.855875 33.4189 1.25721 33.4189 1.8726C33.4189 2.48798 33.6998 2.68865 34.3152 2.68865C33.8336 2.52812 33.6998 2.44785 33.6998 2.20705C33.6998 1.96624 33.9406 1.88598 34.2751 1.88598C34.8102 1.88598 35.1312 2.12678 35.9473 2.12678C33.5794 4.03982 32.857 5.59166 33.8336 6.88932C32.857 7.3843 31.6396 7.13012 30.944 6.2338C30.168 5.21708 30.2483 3.66524 31.8403 2.24718V6.92945L33.2182 5.67193V0.735474C32.9774 0.976276 32.6429 1.13681 32.2817 1.13681C31.7065 1.09668 31.2249 0.815741 30.5694 0.815741C29.8336 0.815741 29.3118 1.21708 29.3118 1.83246C29.3118 2.44785 29.5928 2.64852 30.2082 2.64852C29.7266 2.48798 29.5928 2.40771 29.5928 2.16691C29.5928 1.92611 29.8336 1.84584 30.168 1.84584C30.6898 1.84584 31.0242 2.08664 31.8403 2.08664C29.4858 3.99969 28.75 5.53815 29.7266 6.84919L29.8871 7.08999C30.8637 8.22711 32.9373 8.38765 33.9941 7.08999C35.0108 8.30738 37.2851 8.38765 38.2617 6.88932L39.4389 8.06658L40.9506 6.55487L40.8704 6.43447ZM35.051 6.22042C34.2751 5.2037 34.3553 3.65186 35.9473 2.2338V6.91608C35.5727 6.75554 35.2516 6.51474 35.051 6.22042ZM35.9339 6.91608L37.3118 5.69868V2.19367L37.6329 1.8726L38.2082 2.44785V6.67527C37.566 7.11674 36.7098 7.19701 35.9339 6.91608Z"
                fill="white"
            />
            <path
                d="M21.8202 6.91614L21.4189 6.47467V3.13018L21.9406 2.59507L21.8202 2.5148L21.3653 2.96965L20.5493 2.1536L19.0911 3.61179V1.29741C19.1312 1.01647 19.3319 0.77567 19.6128 0.682025C19.2115 0.641891 18.8369 0.762292 18.556 1.04323C18.275 0.762292 17.8202 0.682025 17.459 0.84256C17.7399 0.882694 17.8202 1.20376 17.8202 1.53821V6.78236L17.6998 6.90276L18.7165 7.91948L19.8938 6.74223L19.7734 6.62182L19.4924 6.90276L19.0911 6.46129V3.82584L19.8269 3.09005L20.1078 3.37099V6.74223L19.9874 6.86263L21.0041 7.89273L22.3419 6.55493L22.2215 6.43453L21.8202 6.91614Z"
                fill="white"
            />
            <path
                d="M17.0971 0.575073C17.0971 0.575073 16.7359 1.91287 14.5285 1.01654C12.9767 0.361026 11.7191 0.655341 11.184 1.09681C10.1272 2.03327 10.5686 2.96972 11.1439 3.33093C10.2877 4.8025 10.7827 6.70216 12.2409 7.59848C13.9533 8.53494 17.0436 7.83929 17.0034 4.54832C16.8429 5.97976 15.5452 6.9831 14.1138 6.82256C13.873 6.78243 13.6188 6.7423 13.4181 6.6219L14.8763 5.20384V2.43461C16.3212 2.72892 17.0971 2.03327 17.0971 0.575073ZM11.2375 3.21052C10.9165 2.92959 10.6623 2.51487 10.9165 2.1938C11.1573 1.87273 11.9332 1.67206 12.8697 1.8326C12.2141 2.15367 11.6523 2.60852 11.2375 3.21052ZM13.1105 6.51487C11.6121 5.77909 11.2777 3.37106 13.0302 1.87273C13.1506 1.91287 13.271 1.953 13.3914 2.03327V6.63527C13.271 6.59514 13.1907 6.55501 13.1105 6.51487Z"
                fill="white"
            />
            <path
                d="M26.0066 3.46456L24.6688 2.12677L22.9163 3.87928V6.68864L22.3945 7.22376L22.5149 7.34416L22.9698 6.90269L23.9865 7.91941L25.6855 6.22042L25.5651 6.10001L24.7892 6.87593L24.2674 6.30068V5.24383L26.0066 3.46456ZM24.1738 5.12343V3.5047L24.9899 4.32075L24.1738 5.12343Z"
                fill="white"
            />
            <path
                d="M76.5093 6.91617L76.0946 6.51483V3.21048L76.9508 4.06667L77.8872 3.17035L76.9106 2.19376L76.0946 3.04995L75.1715 2.15363L73.8203 3.5048L73.9407 3.6252L74.3554 3.17035L74.7969 3.6252V6.91617L74.3153 7.41115L74.3956 7.53155L74.837 7.0767L75.6932 7.93289L77.031 6.5951L76.9508 6.4747L76.5093 6.91617Z"
                fill="white"
            />
            <path
                d="M81.7538 6.91618L81.3525 6.51485V3.0901L81.7939 2.63525L81.7137 2.51485L81.2722 2.9697L80.5364 2.27404L79.921 2.88943C79.426 3.37103 78.9444 3.2105 79.1451 3.00983C79.3056 2.76903 79.2254 2.39445 78.9846 2.23391C78.7438 2.07338 78.3692 2.15364 78.2086 2.39445C78.0481 2.59511 78.0882 2.92956 78.2889 3.0901L79.3458 4.18709C77.3525 5.20381 77.2722 6.87605 78.5297 7.93291L80.0013 6.46133V7.07672L80.8976 7.93291L82.2354 6.59511L82.1551 6.47471L81.7538 6.91618ZM78.6635 3.2105C78.9444 3.37103 79.319 3.37103 79.6401 3.2105L80.0414 3.61184V4.54829L78.6635 3.2105ZM79.4394 6.87605C78.4227 5.81919 79.0381 4.52154 79.5999 4.30749L80.0949 4.80247V6.22053L79.4394 6.87605Z"
                fill="white"
            />
            <path
                d="M84.6432 6.91614L84.2017 6.47467V1.29741C84.2419 1.01647 84.4425 0.77567 84.7368 0.682025C84.3355 0.641891 83.9609 0.762292 83.68 1.04323C83.3991 0.762292 82.9442 0.682025 82.583 0.84256C82.8639 0.882694 82.9442 1.20376 82.9442 1.53821V6.86263L82.4492 7.35761L82.5295 7.43788L82.971 6.99641L83.8673 7.85259L85.2051 6.5148L85.1248 6.43453L84.6432 6.91614Z"
                fill="white"
            />
            <path
                d="M61.458 6.43462L61.0032 6.87609L60.3878 6.26071L59.05 2.15369C58.8092 1.25737 58.5149 0.976429 58.4748 0.481445L58.1938 1.09683C57.7925 0.815894 57.2975 0.695492 56.8159 0.695492C56.3343 0.655358 55.8393 0.77576 55.3978 0.976429C55.0366 1.13696 54.7423 1.49817 54.7022 1.95302C54.7022 2.19382 54.8226 2.448 55.0233 2.5684C54.9029 2.40787 54.8627 2.16706 54.8627 1.95302C54.8627 1.83262 54.9029 1.25737 55.9597 1.25737C56.6554 1.25737 57.2975 1.6587 57.6319 2.31422C56.6554 2.11355 55.6788 2.35436 55.3978 2.88947C55.7189 2.5684 56.8694 2.84934 57.1503 3.34432L55.9731 5.87275C55.8527 5.87275 55.7323 5.87275 55.6119 5.87275C54.7958 5.87275 53.8594 6.36773 53.8594 7.13028C53.8594 7.70553 54.4748 7.98646 55.0366 7.94633C54.5818 7.9062 54.06 7.54499 54.06 7.13028C54.1002 6.76907 54.4614 6.47476 54.836 6.51489C55.8126 6.51489 56.4681 7.09014 57.1102 7.93295L58.8226 6.22058L58.9831 6.87609L60.04 7.97308L61.5115 6.50151L61.458 6.43462ZM57.7122 2.47476L58.2473 4.18713H56.9095L57.7122 2.47476ZM58.1136 6.71556C57.5383 6.27409 56.8159 5.93964 56.0801 5.85937L56.361 5.24399H58.555L58.7557 6.10017L58.1136 6.71556Z"
                fill="white"
            />
            <path
                d="M68.4149 2.0733C68.4149 2.0733 67.358 3.04989 66.9968 3.04989V5.77899L67.9333 5.49805L66.1406 8.02648C66.5955 7.37096 67.4784 7.21043 68.1339 7.66528C68.2945 7.78568 68.4149 7.90608 68.4951 8.06661L70.0871 6.84922V3.98635L68.9099 4.34755L70.5018 2.0733C69.7928 2.68869 68.7761 2.60842 68.4149 2.0733ZM68.8162 6.79571C68.0403 6.55491 67.1841 6.83584 66.7426 7.49136L68.1607 5.45792L68.8162 5.25725V6.79571ZM68.6958 4.4412L68.3346 4.5616V3.26394C68.95 3.42447 69.5921 3.18367 69.9667 2.64855L68.6958 4.4412Z"
                fill="white"
            />
            <path
                d="M73.3784 6.91621L72.9637 6.51487V2.88945H73.6593L74.0206 2.23394H72.9637V0.575073L71.666 1.55166V2.23394H71.0507L70.6895 2.88945H71.666V6.91621L71.1711 7.41119L71.2647 7.49146L71.7062 7.07675L72.5624 7.93293L73.9002 6.55501L73.8199 6.47474L73.3784 6.91621Z"
                fill="white"
            />
            <path
                d="M92.2547 6.91618L91.8533 6.51485V3.0901L92.2948 2.63525L92.2145 2.51485L91.7731 2.9697L90.957 2.15364L90.3416 2.76903C89.8065 3.30414 89.4854 3.22388 89.6861 3.00983C89.8466 2.76903 89.7664 2.39445 89.5256 2.23391C89.2848 2.07338 88.9102 2.15364 88.7497 2.39445C88.5891 2.59511 88.6293 2.92956 88.8299 3.0901L89.8868 4.18709C87.8935 5.20381 87.8132 6.87605 89.0707 7.93291L90.5423 6.46133V7.07672L91.4386 7.93291L92.7764 6.59511L92.6961 6.47471L92.2547 6.91618ZM89.1644 3.2105C89.4453 3.37103 89.8199 3.37103 90.1008 3.17037L90.5423 3.62521V4.6018L89.1644 3.2105ZM89.9403 6.87605C88.9236 5.81919 89.539 4.52154 90.1008 4.30749L90.5958 4.80247V6.22053L89.9403 6.87605Z"
                fill="white"
            />
            <path
                d="M97.9925 6.4747L97.5911 6.91617L97.056 6.43456V3.17035L97.5911 2.64861L97.4573 2.56834L97.056 2.96968L96.1998 2.15363L94.7416 3.6252V3.00981L93.8453 2.15363L92.4941 3.5048L92.5744 3.58506L93.0293 3.17035L93.4306 3.58506L93.4707 6.7155L93.3503 6.8359L94.4072 7.93289L95.6246 6.7155L95.5042 6.63523L95.2232 6.91617L94.7416 6.39443V3.82587L95.3838 3.13021L95.7985 3.58506V6.9563L96.7751 7.93289L98.1129 6.5951L97.9925 6.4747Z"
                fill="white"
            />
            <path
                d="M66.3421 6.4747L65.8872 6.91617L65.4859 6.51483V3.09008L64.5093 2.15363L63.332 3.33088L63.4123 3.46466L63.6933 3.17035L64.215 3.66533V6.26065L63.5327 6.91617L63.118 6.51483V3.09008L62.1414 2.15363L60.8438 3.5048L60.924 3.6252L61.3789 3.17035L61.8605 3.66533V6.91617L61.3254 7.45128L61.4591 7.53155L61.9006 7.0767L62.7167 7.93289L64.215 6.4747V7.0767L65.0712 7.93289L66.4223 6.5951L66.3421 6.4747Z"
                fill="white"
            />
            <path
                d="M87.5327 6.91617L87.0912 6.51483V3.09008L87.5327 2.60847L87.4524 2.52821L87.011 2.96968L86.1949 2.15363L84.8438 3.5048L84.9374 3.6252L85.3789 3.17035L85.7802 3.58506V6.91617L85.3387 7.41115L85.4591 7.49142L85.8605 7.0767L86.7167 7.93289L88.0678 6.5951L87.9876 6.4747L87.5327 6.91617Z"
                fill="white"
            />
            <path
                d="M86.223 0.646675L85.5605 1.30865L86.2225 1.9711L86.885 1.30912L86.223 0.646675Z"
                fill="white"
            />
            <path
                d="M67.5994 20.9896V26.4076H70.1279V28.3876H65.1914V20.9762H67.5994V20.9896Z"
                fill="white"
            />
            <path
                d="M73.5796 20.9897V28.4011H71.1582V20.9897H73.5796Z"
                fill="white"
            />
            <path
                d="M77.191 20.9897L78.5823 25.284L79.9736 20.9897H82.5556L79.7596 28.4011H77.3917L74.5957 20.9897H77.191Z"
                fill="white"
            />
            <path
                d="M88.8571 20.9896V22.9026H86.0076V23.7053H88.6966V25.605H86.0076V26.4611H88.9642V28.3876H83.5996V20.9762H88.8571V20.9896Z"
                fill="white"
            />
            <path
                d="M91.0644 25.7121C91.7466 26.2873 92.7232 26.5148 93.0443 26.5148C93.3654 26.5148 93.5928 26.4211 93.5928 26.2071C93.5928 25.993 93.3252 25.9128 93.0577 25.8191L91.9874 25.4713C90.9573 25.1368 90.2885 24.4813 90.2885 23.3442C90.2885 21.6318 91.8269 20.9094 93.3252 20.9094C94.3152 20.9094 95.3186 21.2572 95.9607 21.8057L95.0376 23.5181C94.4757 23.0231 93.6597 22.8091 93.1781 22.8091C92.8838 22.8091 92.6697 22.9027 92.6697 23.09C92.6697 23.3843 93.2182 23.4512 93.7801 23.6385L94.2751 23.7991C95.3721 24.1603 96.0008 24.8425 96.0008 25.9529C96.0008 27.7188 94.4089 28.5215 92.8436 28.5215C91.9874 28.5215 90.9975 28.2807 89.9941 27.5315L91.0644 25.7121Z"
                fill="white"
            />
            <path
                d="M98.3557 26.1802C99.1316 26.1802 99.6667 26.595 99.6667 27.3575C99.6667 28.12 99.1316 28.5214 98.3557 28.5214C97.5664 28.5214 97.0313 28.1067 97.0313 27.3575C97.0312 26.595 97.5797 26.1802 98.3557 26.1802Z"
                fill="#FFC70A"
            />
            <path
                d="M70.2749 11.8793V13.9529H67.7331V14.7288H70.1144V16.789H67.7599V18.9295H65.0977V11.8793H70.2749Z"
                fill="white"
            />
            <path
                d="M71 15.6522C71 13.3378 72.6321 12 74.8796 12C77.1271 12 78.7592 13.3378 78.7592 15.6522C78.7592 17.9666 77.1271 19.291 74.8796 19.291C72.6187 19.3043 71 17.9666 71 15.6522ZM76.097 15.612C76.097 14.8227 75.6689 14.2475 74.8662 14.2475C74.0769 14.2475 73.6355 14.8361 73.6355 15.612C73.6355 16.388 74.0903 16.9766 74.8662 16.9766C75.6689 16.9632 76.097 16.388 76.097 15.612Z"
                fill="white"
            />
            <path
                d="M79.2109 15.411C79.2109 13.0966 80.843 11.7589 83.0905 11.7589C85.338 11.7589 86.9701 13.0966 86.9701 15.411C86.9701 17.7254 85.338 19.0498 83.0905 19.0498C80.843 19.0498 79.2109 17.7254 79.2109 15.411ZM84.3079 15.3709C84.3079 14.5816 83.8798 14.0063 83.0772 14.0063C82.2879 14.0063 81.8464 14.595 81.8464 15.3709C81.8464 16.1468 82.3012 16.7354 83.0772 16.7354C83.8798 16.7221 84.3079 16.1468 84.3079 15.3709Z"
                fill="white"
            />
            <path
                d="M87.5586 13.9262V11.8793H93.378V13.9262H91.7726V18.9429H89.1372V13.9262H87.5586Z"
                fill="white"
            />
            <path
                d="M93.9531 11.8793H96.8829L97.7257 14.1937L98.5819 11.8793H101.485L99.0367 16.3743V18.9295H96.3745V16.3743L93.9531 11.8793Z"
                fill="white"
            />
            <path
                d="M102.141 16.7222C102.917 16.7222 103.452 17.1369 103.452 17.8861C103.452 18.6353 102.917 19.05 102.141 19.05C101.352 19.05 100.816 18.6353 100.816 17.8861C100.83 17.1369 101.365 16.7222 102.141 16.7222Z"
                fill="#FFC70A"
            />
            <path
                d="M65.1914 30.381H67.7733V33.2305H69.9138V30.381H72.5091V38.2606H69.9272V35.3442H67.7867V38.2606H65.2048V30.381H65.1914Z"
                fill="white"
            />
            <path
                d="M79.6135 30.381V32.4145H76.59V33.2707H79.4395V35.2907H76.59V36.2004H79.7339V38.2606H74.0215V30.381H79.6135Z"
                fill="white"
            />
            <path
                d="M86.9565 30.9429C87.5318 31.3443 87.9331 32.0265 87.9331 32.8827C87.9331 33.6988 87.6789 34.2473 87.3846 34.6218C87.1037 34.9697 86.7826 35.157 86.6221 35.264L88.388 38.2606H85.4181L84.1605 35.6386H83.8261V38.2606H81.2441V30.381H84.6689C85.6455 30.381 86.3813 30.5416 86.9565 30.9429ZM85.0435 33.5516C85.1639 33.458 85.3244 33.3509 85.3244 33.0031C85.3244 32.6553 85.1505 32.5483 85.0435 32.468C84.9231 32.3744 84.7625 32.3208 84.4682 32.3208H83.8127V33.6854H84.4682C84.7492 33.6854 84.9365 33.6319 85.0435 33.5516Z"
                fill="white"
            />
            <path
                d="M95.4924 30.381V32.4145H92.469V33.2707H95.3185V35.2907H92.469V36.2004H95.6128V38.2606H89.9004V30.381H95.4924Z"
                fill="white"
            />
            <path
                d="M98.5297 35.9061C99.3591 35.9061 99.921 36.3476 99.921 37.1503C99.921 37.953 99.3457 38.381 98.5297 38.381C97.7003 38.381 97.125 37.953 97.125 37.1503C97.125 36.3476 97.7003 35.9061 98.5297 35.9061Z"
                fill="#FFC70A"
            />
            <path
                d="M61.7937 38.127V11.9062H48.991L35.1582 38.127H44.2819L46.5161 33.9129H52.8171L52.7502 38.127H61.7937ZM49.4325 27.9464L53.1248 20.7758H53.312L53.1248 27.9464H49.4325Z"
                fill="#FFC70A"
            />
            <path
                d="M36.3087 11.9062H35.6265L29.098 23.1303H29.0847V22.4748V11.9062H26.8104H21.6064L15.0245 23.0902V11.9062H6.18164V26.2875V38.127H15.1984L20.8572 26.5283V38.127H30.7836L44.7903 11.9062H36.3087Z"
                fill="#FFC70A"
            />
        </svg>
    )
}
